import React, { Component } from 'react'

import "../css/vertical.css";
import "../css/BusinessChance.css";

import moment from 'moment';

import Config from "../config/Config";
import Cache from '../frame/Cache';

import AttributeSearch from './search/AttributeSearch';
import WidgetAjax from "../widget/WidgetAjax";
import WidgetCondition from '../widget/WidgetCondition';
import WidgetTable from '../widget/WidgetTable'
import WidgetPageTable from '../widget/WidgetPageTable'
import WidgetSelect from '../widget/WidgetSelect';

import WidgetMessage from '../widget/WidgetMessage';

import LoadingTag from "../img/frame/loading.gif";
import TitleLeft from "../img/BusinessChance/TitleLeft.svg";
import BackToTop from "../img/BusinessChance/backToTop.svg";
import Magnifier from "../img/BusinessChance/Magnifier-1.svg";


import WidgetDrawer from '../widget/WidgetDrawer';
import EntityDetail from './EntityDetail';

 class vertical extends Component
{

    constructor(props)
    {
        super(props)
        
        const url = Config.getBasePath()
        const OBJECTTYPE = Config.getOBJECTTYPE();

        this.state={
            url:url,
            basePath:Config.getBasePath(),
            OBJECTTYPE: OBJECTTYPE,
            businessSearchInput:"商机主题关键字搜索",
            topData:[],
            curIndex:0,
            verticalInput:"商机主题关键字搜索",
            conditions: {},     // 存储条件筛选的信息
            attributes: [],
            flag:false,
            font:"",
            total : 0,
            options: {
                records: 10,
                rowKey: "ENTID",
                keyWordColumnName: "ENTNAME",
                keyWord: undefined,
                checkedKey: "ENTID",
                check: true,
                isAutoHeight: true,
            },
            columns:[],
            columns1: [
                [
                    {"name":"ENTID","title":"ENTID","type":"string","description":"主体ID","properties":{"id":true, "hidden":true}},
                ],
                [
                    // {"name":"UNISCID","title":"统一社会信用代码","type":"string","description":"统一社会信用代码","properties":{"display":"show"}},
                    {"name":"KNAME","title":"矿山名称","type":"string","description":"矿山名称","properties":{click: "entityDetail"}},
                ],
                [
                    {"name":"ENTNAME","title":"采矿权人","type":"string","description":"采矿权人","properties":{hidden:false}},

                ],
                [
                    {"name":"MINE_KIND","title":"开采矿种","type":"string","description":"开采矿种","properties":{hidden:false}},
                    {"name":"MINE_TYPE","title":"开采方式","type":"string","description":"开采方式","properties":{hidden:false}},
                    {"name":"CERT_DATE","title":"矿权发证日期","type":"string","description":"矿权发证日期","properties":{hidden:false}},
                ],
                [
                    { name: 'TEL', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false, transform: "transformTEL"} },
                ],
               
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '添加监控', click: "addMonitor" },
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }
                ]
            ],
            columns2: [
                [
                    {"name":"ENTID","title":"ENTID","type":"string","description":"主体ID","properties":{"id":true, hidden:true}},
                ],
                [
                    {"name":"PNAME","title":"项目名称","type":"string","description":"项目名称","properties":{hidden:false ,click: "entityDetail"}},
                ],
                [
                    {"name":"ENTNAME","title":"土地使用权人","type":"string","description":"土地使用权人","properties":{hidden:false}},

                ],
                [
                    {"name":"DUSE","title":"土地用途","type":"string","description":"土地用途","properties":{hidden:false}},
                    {"name":"DSUPPLY","title":"供地方式","type":"string","description":"供地方式","properties":{hidden:false}},
                    {"name":"TDATE","title":"合同签订日期","type":"string","description":"合同签订日期","properties":{hidden:false}},
                ],
                [
                    { name: 'TEL', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false, transform: "transformTEL"} },
                ],
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '添加监控', click: "addMonitor" },
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }
                ]
            ],
            isBackToTop:false,
            isClickLeft:false,
            messageOptions: {
                title: '添加监管'
            },
            checkData: [],
            checkDataLength:0,
            tableOptions: {
                records: 10,
                rowKey: "ENTID",
                isAutoHeight: true,
                checkedKey: "ENTID",
                keyWordColumnName:"ENTNAME",
                check: true,
            },
            checkedKeys:[],
            page:1,
            loading:false,
            drawerOptions: {
                size: 'lg',
                button: false,
            },
            scrollTop: 0,
            userCatalogData:[],
            tableData:[],
            tableCode:undefined,
            tagsData:[],
            checkIt:"",
            detailData:undefined,
            selectoptions:{
                cleanable : true,
            },
            groupData: [
                {label:'不限', value:'0'},
                {label:'正序', value:'1'},
                {label:'倒序', value:'2'}
            ],
            distanceData: [
                {label:'不限', value:'0'},
                {label:'距离最远', value:'1'},
                {label:'距离最近', value:'2'}
            ],
            group:undefined,
            distance:undefined,
        };


        this.readCondition = this.readCondition.bind(this);
        this.onReadCondition = this.onReadCondition.bind(this);
        this.fontDom = this.fontDom.bind(this);
        this.adsorbBody = this.adsorbBody.bind(this);
        this.changeisClickLeft = this.changeisClickLeft.bind(this);

        this.export = this.export.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.transformTEL = this.transformTEL.bind(this);
        this.transformOperations = this.transformOperations.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);

        this.addMonitors = this.addMonitors.bind(this)

        this.addCRMs = this.addCRMs.bind(this)

        this.pageTurning = this.pageTurning.bind(this);
        this.tableOnCheck = this.tableOnCheck.bind(this);

        this.getHead = this.getHead.bind(this);
        this.setScrollTop = this.setScrollTop.bind(this);

        this.loadUserCatalog = this.loadUserCatalog.bind(this);
        this.onLoadUserCatalog = this.onLoadUserCatalog.bind(this);

        this.search = this.search.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.attributeOnChange = this.attributeOnChange.bind(this);
        this.cleanCondition = this.cleanCondition.bind(this);
        
    }

    componentDidMount()
    {
        this.loadUserCatalog();
    }

    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    setMessageRef = (ref) => {
        this.messageRef = ref;
    }

    setScrollTop (top,bottom) {
         this.head.scrollTop = top
    }

    /**
     * Tabs切换
     * @param {*} params 
     */
     changebusinessThemeListActive( e, params, item)
     {
        let { topData } = this.state;
        let id = params==="beforeHomePage"? e.id.split("_")[0]: e.currentTarget.id.split("_")[0];
        let ele = document.getElementById(id);
        let font = item.children[0].name

         this.setState({curIndex:params,font:font,scrollTop:0},()=>{
            this.setScrollTop(this.state.scrollTop)
            topData.forEach((item,ind)=>{
                 document.getElementById(item.id).className = "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular";
             })
                 document.getElementById(item.id).className = "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive";
         });
     }

     /**
     * 表格事件函数
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @param {*} tableData
     * @returns 
     */
    tableOnEvent(type, data, value, event,tableData) 
    {
        switch (type) 
        {
            case "transformTEL":
            {
                data = JSON.parse(data);

                 return this.transformTEL(data, value);
            }
            case "entityDetail":
            {
                data = JSON.parse(data);
                
                this.setState({ detailData: data });
                
                this.drawerRef.open();

                break;
            }
            case "addMonitor":
            {
                data = JSON.parse(data);

                this.addMonitor(data);

                break;
            }
            case "removeMonitor":
            {
                data = JSON.parse(data);

                this.removeMonitor(data);

                break;
            }
            case "addFavor":
            {
                data = JSON.parse(data);

                this.addFavor(data);

                break;
            }
            case "removeFavor":
            {
                data = JSON.parse(data);

                this.removeFavor(data);

                break;
            }
            case "addCRM":
            {
                data = JSON.parse(data);
                this.addCRM(data);
                break;
            }
            case "removeCRM":
            {
                data = JSON.parse(data);
                this.removeCRM(data);
                break;
            }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            default:
                break;
        }
    }

    /**
     * 表格多选函数
     * @param {*} data 
     */
     tableOnCheck(data) 
     {
         this.state["checkData"] = data;
 
         this.setState({ checkData:data, checkDataLength: data.length });
     }


     /**
     * 操作格式化
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
      transformOperations(data, content) 
      {
          if (content.props !== undefined && content.props.children !== undefined) 
          {
              for (let i = 0; i < content.props.children.length; i++) 
              {
                  let child = content.props.children[i];
  
                  if (child.props.className === "addMonitor") 
                  {
                      if (data.MONITOR === true) {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
                  else if (child.props.className === "removeMonitor")
                  {
                      if (data.MONITOR !== true) 
                      {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
                  else if (child.props.className === "addCRM") 
                  {
                      if (data.CRM === true) 
                      {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
                  else if (child.props.className === "removeCRM") 
                  {
                      if (data.CRM !== true) 
                      {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
                  else if (child.props.className === "addFavor") 
                  {
                      if (data.FAVOR === true) 
                      {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
                  else if (child.props.className === "removeFavor") 
                  {
                      if (data.FAVOR !== true)
                       {
                          content.props.children.splice(i, 1);
                          i--;
                      }
                  }
              }
          }
  
          return content;
      }

      /**
     * 联系方式转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformTEL( data, content )
    {
        if( data.TEL!==undefined && data.TEL!==null && data.TEL.length>0 )
        {
            let value = "", isFirst = true;
            for( let item of data.TEL )
            {
                if( isFirst )
                {
                    value = `<label className='tel'>`+item.tel+`</label>`;
                    isFirst = false;
                }
                else
                {
                    value += `<label className='tel'>`+item.tel+`</label>`;
                }
            }

            return value;
        }
    }

     /**
     * 左侧列表吸附效果
     */
    adsorbBody(e)
    {
        if( e.target.id==="vertical-body" )
        {
            let scrollTopX = e.target.scrollTop;
            document.getElementById("vertical-left").style.top = scrollTopX+"px";
             
            if(scrollTopX>600)
            {
                if(this.state.isBackToTop != true)
                {
                    this.setState({
                        isBackToTop:true,
                    });
                }
            }
            else
            {
                if(this.state.isBackToTop != false)
                {
                    this.setState({
                        isBackToTop:false
                    });
                }
            }
        }
    }

    /**
     * 表格翻页
     * @param {*}} page 
     */
     pageTurning(page) 
     {
         this.search(page);
     }
 


    changeisClickLeft()
    {
        let {isClickLeft} = this.state;
        if(isClickLeft)
        {
            this.setState({
                isClickLeft:false
            });
        }
    }

     
     /**
     * 属性条件变化回调函数
     * @param {*} conditions 
     */
    attributeOnChange(conditions) 
    {
        this.setState({ conditions: conditions });
    }

       /**
     * 清空条件
     */
    cleanCondition() 
    {
        this.setState({ conditions:{}, flag:true });
    }
  
    /**
     * 构建 filter
     */
    buildFilter() 
    {
        let { attributes, conditions } = this.state, filters = {};

        const widgetCondition = new WidgetCondition();

        if (attributes !== undefined && attributes !== null && attributes.length > 0) 
        {
            for ( let attribute of attributes ) 
            {
                let expression, key = attribute.name;

                if (attribute.type === "DIMENSION") 
                {
                    key = attribute.content.code;
                }

                if (conditions[key] !== undefined && conditions[key] !== null)
                {
                    switch (attribute.type) 
                    {
                        case "STRING":
                        {
                            if (attribute.index === "TEXT") {
                                expression = "${" + key + "} has '" + conditions[key] + "'";
                            }
                            else {
                                expression = "${" + key + "} = '" + conditions[key] + "'";
                            }

                            filters[key] = expression;
                            break;
                        }
                        case "DATE":
                        case "NUMBER":
                        case "INTEGER":
                        {
                            if (key === "ESTDATE") 
                            {
                                if (conditions[key].start !== undefined && conditions[key].start !== "")
                                {
                                    let startValue = moment(moment(conditions[key].start, 'YYYYMMDD')).format('YYYY-MM-DD');

                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        let endValue = moment(moment(conditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: startValue }, max: { code: key, operator: 'SE', value: endValue } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + conditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        let endValue = moment(moment(conditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = '${' + key + '} <= ' + endValue;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }
                            else 
                            {
                                if (conditions[key].start !== undefined && conditions[key].start !== "") 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: conditions[key].start }, max: { code: key, operator: 'SE', value: conditions[key].end } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + conditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        expression = '${' + key + '} <= ' + conditions[key].end;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }

                            filters[key] = expression;

                            break;
                        }
                        case "NOMINAL":
                        {
                            if (conditions[key] !== undefined) 
                            {
                                let expression = widgetCondition.createCondition(key, "point", { code: key, operator: "E", value: conditions[key] });

                                filters[key] = expression;
                            }
                            else 
                            {
                                filters[key] = undefined;
                            }
                            break;
                        }
                        case "DIMENSION":
                        {

                            key = attribute.content.code;

                            if (attribute.index === "SINGLE") 
                            {
                                if (conditions[key] !== undefined && conditions[key] !== null) 
                                {
                                    let item = conditions[key];

                                    let code = attribute.content.code;

                                    expression = widgetCondition.createCondition(item.code, "point", { code: item.code, operator: "E", value: item.value });

                                    filters[code] = expression;

                                }
                            }
                            else 
                            {
                                if (conditions[key] !== undefined && conditions[key] !== null) 
                                {
                                    let treeConditions = conditions[key], params = [];

                                    for (let code in treeConditions) 
                                    {
                                        let set = [];
                                        for (let item of treeConditions[code]) 
                                        {
                                            set.push(item.value);
                                        }
                                        params.push({ code: code, operator: 'IN', set: set });
                                    }

                                    if (params.length > 0) 
                                    {
                                        expression = widgetCondition.createCondition(attribute.content.code, "composite", params);
                                    }

                                    filters[attribute.content.code.substring(0, 4)] = expression;

                                }
                            }
                        }
                    }
                }
            }
        }


        return filters;
    }

    fontDom(e,value,code)
    {
        let {columns1,columns2} = this.state;

        this.setState({font:value.name,tableCode:code, schema: value.content.schema, checkIt:value.id }, 
            () => {
                this.readCondition( code );
                this.search(1);
            }
        );

        switch(code)
        {
            case "MINING":
            {
                this.setState({columns:columns1})
                break;
            }
            case "PROSPECTING":
            {  
                // this.setState({columns:columns1})
                // break;
            }
            case "LAND":
            {
                this.setState({columns:columns2})
                break;
            }
        }
       
        
    }

    /**
    * 导出按钮
    */
    export( type ) 
    {
        let { messageOptions, total, checkData } = this.state;

        messageOptions["isMessage"] = false;

        // type = "1";

        // if ( type==="1" ) 
        // {
        //     if( checkData === undefined || checkData === null || checkData.length===0 ) 
        //     {
        //         messageOptions["isMessage"] = true;

        //         messageOptions["message"] = `没有选中的记录?`;

        //         messageOptions["title"] = "导出";

        //     }
        //     else 
        //     {
        //         messageOptions["message"] = `确定要导出当前选中的记录吗?`;
        //     }
        // }
        // else if (type === "2") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前20条记录吗?`;
        // }
        // else if (type === "3") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前50条记录吗?`;
        // }
        // else if (type === "4") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前100条记录吗?`;
        // }
        // else 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的全部记录吗?`;
        // }

        if( checkData!==undefined && checkData!==null && checkData.length>0 )
        {
            messageOptions["message"] = `确定要导出当前选中的 ` + checkData.length + ` 记录吗?`;
        }
        else
        {
            messageOptions["message"] = `确定要导出符合条件的全部记录吗?`;
        }

        messageOptions['confirmFunction'] = this.exportConfirm;

        messageOptions["title"] = "选中确认";

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }


    /**
     * 添加监管
     * @param {*} data 
     */
     addMonitor(data) 
     {
 
         let { messageOptions } = this.state;
 
         messageOptions["isMessage"] = false;
 
         messageOptions['confirmFunction'] = this.addMonitorConfirm;
 
         messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到监管对象中吗?`;
 
         messageOptions["title"] = "添加监管";
 
         this.state['messageOptions'] = messageOptions;
 
         this.state['entityData'] = data;
 
         this.messageRef.open();
 
     }
 
     addMonitors() 
     {
 
         let { messageOptions, checkData } = this.state, ENTNAMEs = "", isFirst = true;
 
         messageOptions["isMessage"] = false;
 
         if( !checkData.length ) 
         {
             messageOptions["isMessage"] = true;
 
             messageOptions["message"] = `请选择需要添加监控的企业`;
 
             messageOptions["title"] = "添加监控企业";
 
             this.state['messageOptions'] = messageOptions;
 
             this.messageRef.open();
         }
         else 
         {
             for (let item of checkData) 
             {
                 if (isFirst === true) 
                 {
                     ENTNAMEs = `'` + item.ENTNAME + `'`
 
                     isFirst = false;
                 }
                 else 
                 {
                     ENTNAMEs += `, '` + item.ENTNAME + `'`
                 }
             }
 
             messageOptions["message"] = `确定要把 '` + ENTNAMEs + `' 加入监控对象吗?`;
 
             messageOptions['confirmFunction'] = this.addMonitorConfirm;
 
             messageOptions["title"] = "添加监控";
 
             this.state['isBatch'] = true;
             this.state['entityData'] = undefined;
             this.state['messageOptions'] = messageOptions;
 
             this.messageRef.open();
         }
     }
 
     addMonitorConfirm() 
     {
         const { basePath, entityData, isBatch, checkData } = this.state;
 
         let params = {};
 
         if (isBatch === true)
          {
             let ENTIDs = [];
 
             for (let item of checkData) 
             {
                 ENTIDs.push(item.ENTID);
             }
 
             params["ENTIDs"] = ENTIDs;
         }
         else 
         {
             params["ENTID"] = entityData.ENTID;
         }
 
         WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
     }
 
     onAddMonitor(result, params, backParam) 
     {
         if (result.status === 0) 
         {
             let { messageOptions, isBatch, checkData } = this.state;
 
             messageOptions["isMessage"] = true;
 
             if (isBatch === true) 
             {
                 let ENTNAMEs = "", isFirst = true;
 
                 for (let item of checkData) 
                 {
                     if (isFirst === true) 
                     {
                         ENTNAMEs = `'` + item.ENTNAME + `'`
 
                         isFirst = false;
                     }
                     else 
                     {
                         ENTNAMEs += `, '` + item.ENTNAME + `'`
                     }
                 }
 
                 if (result.result === checkData.length) 
                 {
                     messageOptions["message"] = ENTNAMEs + `' 全部成功加入监控对象中！`;
                     setTimeout(() => { this.props.history.go() }, 1300)
                     this.search(1);
                 }
                 else 
                 {
                     messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功添加监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                     setTimeout(() => { this.props.history.go() }, 1300)
                     this.search(1);
                 }
             }
             else 
             {
                 messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加进监控对象中！`;
                 this.search(1);
             }
 
             messageOptions["title"] = "添加监控";
 
             this.state['entityData'] = undefined;
             this.state['checkData'] = [];
             this.state['messageOptions'] = messageOptions;
 
             this.messageRef.open();
         }
         else if (result.status === 10) 
         {
             Cache.logout(this.props);
         }
 
     }


     /**
     * 取消监管
     * @param {*} data 
     */
    removeMonitor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从监管对象中移除吗?`;

        messageOptions["title"] = "取消监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }

    removeMonitorConfirm() 
    {
        const { basePath, entityData } = this.state;

        let params = {
            ENTID: entityData.ENTID
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entityData } });
    }

    onRemoveMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {

            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监管对象中移除！`;

            messageOptions["title"] = "取消监管";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.state['entityData'] = undefined;

            this.search(1);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    
    /**
     * 添加 CRM
     * @param {*} data 
     */
         addCRM(data) 
         {
             let { messageOptions } = this.state;
             messageOptions["isMessage"] = false;
             messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加至CRM中吗?`;
             messageOptions['confirmFunction'] = this.addCRMConfirm;
             messageOptions["title"] = "添加CRM";
             messageOptions["entData"] = data
     
             this.state['messageOptions'] = messageOptions;
     
             this.messageRef.open();
         }
     
         /**
          * 将选中的企业添加进CRM
          */
         addCRMs() 
         {
             let { checkData, messageOptions } = this.state
     
             if (!checkData.length) 
             {
                 messageOptions["isMessage"] = true;
     
                 messageOptions["message"] = `请选择要添加CRM的企业`;
     
                 messageOptions["title"] = "添加CRM";
     
                 this.state['messageOptions'] = messageOptions;
     
                 this.messageRef.open();
             }
             else 
             {
                 let Objs, isFirst = true;
     
                 for (let item of checkData) 
                 {
                     if (isFirst)
                     {
                         Objs = item.ENTNAME;
     
                         isFirst = false;
                     }
                     else 
                     {
                         Objs += ", " + item.ENTNAME;
                     }
                 }
     
                 messageOptions["isMessage"] = false;
     
                 messageOptions['confirmFunction'] = this.addCRMConfirm;
     
                 messageOptions['message'] = `您确定要将 ${Objs} 加入CRM吗?`;
     
                 this.state['messageOptions'] = messageOptions;
     
                 this.state["isBatch"] = true
     
                 this.messageRef.open();
             }
         }
     
         addCRMConfirm() 
         {
             let { messageOptions, basePath, isBatch, checkData } = this.state, params;
     
             if (isBatch === true) 
             {
                 let ENTIDs = [];
     
                 for (let item of checkData) 
                 {
                     ENTIDs.push(item.ENTID);
                 }
     
                 params = {
                     "ENTIDs": ENTIDs
                 }
     
                 WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { checkData } });
             }
             else 
             {
                 let data = messageOptions["entData"];
     
                 params = {
                     "ENTID": data["ENTID"]
                 };
     
                 WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.ENTNAME } });
             }
         }
     
         onAddCRM(result, params, backParam) 
         {
             if (result.status === 0) 
             {
                 if (backParam.checkData) 
                 {
                     let { messageOptions } = this.state, isFirst = true, addCRMName = '';
     
                     messageOptions["isMessage"] = true;
     
                     for (let item in backParam.checkData) 
                     {
                         if (isFirst) 
                         {
                             addCRMName = backParam.checkData[item].ENTNAME
                             isFirst = false
                         }
                         else 
                         {
                             addCRMName += ", " + backParam.checkData[item].ENTNAME
                         }
                     }
                     
                     messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!`;
                     messageOptions["title"] = "添加成功";
                     this.state['messageOptions'] = messageOptions;
                 }
                 else 
                 {
                     let { messageOptions } = this.state;
                     messageOptions["isMessage"] = true;
                     messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
                     messageOptions["title"] = "添加成功";
                     this.state['messageOptions'] = messageOptions;
                 }
     
                 this.messageRef.open();
             }
             else if (result === 10) 
             {
                 Cache.logout(this.props);
             }
             else if (result.status === -1) 
             {
                 let { messageOptions } = this.state;
                 messageOptions["isMessage"] = true;
                 messageOptions["message"] = `发生错误，添加失败！`;
                 messageOptions["title"] = "错误";
                 this.state['messageOptions'] = messageOptions;
     
                 this.messageRef.open();
             }
     
             this.state["isBatch"] = false
         }

         getHead(el) {
            this.head = el;
        }


    //顶部数据
    loadUserCatalog()
    {
        let { basePath } = this.state;

        let params = undefined;

        WidgetAjax.ajax({url: basePath + "/search/database", params: params , callback: this.onLoadUserCatalog});
    }

    onLoadUserCatalog( result )
    {
        
        if (result.status === 0) 
        {
            let data = result.results,
                arr = [];

            data.forEach((item)=>{
                if(item.content != null )
                {
                    arr.push(item)
                }
            })
            this.setState({topData:arr, font:arr[0].name,checkIt:arr[0].id });

            this.state["schema"] = arr[0].content.schema;

            this.readCondition(arr[0].code);

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    //  读取 条件查询条件
    readCondition( code ) 
    {
        let { url } = this.state;

        WidgetAjax.ajax({ url: url + '/search/attribute', params: { "database_code": code }, callback: this.onReadCondition });
    }

    onReadCondition(result, params) 
    {
        if (result.status === 0) 
        {
            this.setState({ attributes: result.results});

            this.search(1);
        }else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

     /**
     * 查询数据
     * @param {*} page 
     */
    search(page) 
    {
        let { tableOptions, url, schema, group, distance} = this.state;

        let filters = this.buildFilter();

        if (page === undefined || page === null || page === "") 
        {
            page = 1;
        }

        let params = {
            schema: schema,
            page: page,
            records: tableOptions.records,
            filters: filters,
            sorts:{
                REGCAP:"DESC"
            }
        }
        // if(group) params['group'] = group;
        // if(distance) params['distance'] = distance;

        sessionStorage.setItem('page', page);

        WidgetAjax.ajax({ url: url + '/report/data', params: params, callback: this.onSearch });

        this.setState({ loading: true, page: page });
    }

    onSearch(result, params) 
    {
        if (result.status === 0) 
        {
            this.setState({ tableData: result.results, total: result.total, loading: false });
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props)
        }
        else
        {
            this.setState({ tableData: [], total: 0, loading: false });
        }
    }

    changeFilterType = async (value,type) =>
    {
        switch(type)
        {
            case 'e':
                this.setState({ filterTypeValue: value });
                break;
            case 'group':
                await this.setState({ group: value });
                // this.search();
                break;
            case 'distance':
                await this.setState({ distance: value });
                // this.search();
                break;
        }
    }

    // a(){
    //     let { tableOptions, url, schema} = this.state;

    //     WidgetAjax.ajax({ url: url + '/scrm/single_intimacy', params: undefined, callback: this.ona }); 
    // }

    // ona(result){
    //     console.log(result)
    // }

    render() {

        let { topData, verticalInput, curIndex, conditions, attributes, flag, font, options,
            columns,total, tableData, messageOptions, checkDataLength, tableOptions,
            checkedKeys, page, loading, drawerOptions, detailData, columns1,columns2, checkIt, selectoptions, groupData, distanceData, group, distance } = this.state;

        return (
            <div id="vertical-body" className="vertical-body display-flex overflow-auto" onWheel={this.changeisClickLeft} onScroll={(e)=>{this.adsorbBody(e)}} ref={this.getHead}>
                <div id="vertical-left" className="vertical-left background-fff radius-5 overflow-hidden isSuctionTop-left">
                        <div className="vertical-content">
                            <div className="leftListSearch borderbottom-F8FBFF">
                                <input  placeholder={verticalInput} 
                                        className="themeSearchInput font-PingFangFC" 
                                />
                                <img src={Magnifier} className={verticalInput? "Magnifier-1" : "display-none"}/>
                            </div>
                            {/* {
                                topData.map((item,index) => {
                                    return (
                                        <div onClick={(e)=>{this.changebusinessThemeListActive(e,index,item)}}
                                            key={item.id}
                                            id={item.id}
                                            className={index===0?
                                                "leftList lineheight-50 cursor-pointer paddingLeft-40 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive":
                                                "leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular"
                                            }
                                        >
                                            {item.title}
                                        </div>
                                    )
                                })
                            } */}
                            <div className="leftList lineheight-50 cursor-pointer paddingLeft-44 borderbottom-F8FBFF font-14 font-PingFangFCRegular leftListActive">垂直检索</div>
                        </div>
                </div>
                <div id="vertical" className="vertical-right">
                    <div className="verticalTop">
                            <div className="top-bottom">
                                <div className="top">
                                    <span className="title"><img src={TitleLeft} />垂直检索</span>
                                </div>
                                <div className="bottom">
                                    {
                                        topData.map((item,index)=>{
                                            return (
                                                <span key={item.id} style={{display:"block",cursor:"pointer"}} 
                                                      className={checkIt === item.id?"tags-active":""}
                                                      onClick={(e)=>{this.fontDom(e,item,item.code)}}>
                                                    {item.name}
                                                </span>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            
                    </div>

                    <div className="vertical-center">
                        <div className="fonts"><span>{font}</span></div>
                        <div className="enterprise">
                            <div id="details" className='content-tag-left content-tag-all'>
                                <div className="search-condition" style={{ borderRadius:"8px"}}>
                                    <AttributeSearch notify={this.attributeOnChange} values={conditions} attributes={attributes} flag={flag}></AttributeSearch>
                                    <div className="condition-button">
                                        <label  
                                            onClick={() => { this.cleanCondition() }}
                                        >清空</label>
                                        <label className="determine-label"
                                            onClick={() => { this.search(1) }}
                                        >查询</label>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div className="vertical-bottom">
                        <div className="content-title Addroles2" style={{ height: "60px", paddingRight:"36px", background:"#ffffff"}}>
                            <div className='search-left'>
                                <p>为您找到 <span className='num'>{total}</span> 家企业</p>
                            </div>
                            <div className="monitoring ">
                                <span className="selectedB">已选择 <span className="selectedBM">{checkDataLength}</span></span>
                                <button className="export-button" onClick={this.export}><img className="export" src={require("../img/exportData.svg")} />导出数据</button>
                                {/* <div style={{marginRight:'20px',float:'left'}}>
                                    <span style={{ float: "left", fontSize:"14px", color:'#333' }}>{"推荐度排序 "}&nbsp;&nbsp;</span>
                                    <WidgetSelect options={selectoptions} data={groupData} className="SelectS"  onSelect={(value)=>this.changeFilterType(value,'group')} defaultValue={group} ></WidgetSelect>
                                </div>
                                <div style={{marginRight:'20px',float:'left'}}>
                                    <span style={{ float: "left", fontSize:"14px", color:'#333' }}>{"距离排序"}&nbsp;&nbsp;</span>
                                    <WidgetSelect options={selectoptions} data={distanceData} className="SelectS"  onSelect={(value)=>this.changeFilterType(value,'distance')} defaultValue={distance} ></WidgetSelect>
                                </div> */}
                                <div className="addButton click" onClick={() => { this.addMonitors() }}>
                                    <span>添加监控</span>
                                </div>
                                <div className="closeCRMButton" onClick={() => { this.addCRMs(2) }}>
                                    <span>添加CRM</span>
                                </div>
                            </div>
                        </div>

                        <div className="content-bottom">
                            <div id="contentTagReport" className="content-report content-canvas content-bottom-frame">
                                <div className="content-report" style={{ minHeight: "522px" }}>
                                    <WidgetPageTable 
                                    options={tableOptions} columns={font==="采矿"?columns1:columns} data={tableData} total={total} loading={loading}
                                    checkedKeys={checkedKeys} notify={this.tableOnEvent} onCheck={this.tableOnCheck} pageTurning={this.pageTurning} page={page}
                                     />
                                </div>
                            </div>
                        </div> 

                    </div>

                </div>

                    <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                        <div className="frame-body" >
                            <EntityDetail data={detailData} search={this.search} attributes={attributes} font={font}></EntityDetail>
                        </div>
                    </WidgetDrawer>

                <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />
            </div>
        )
    }
}

export default vertical
